// extracted by mini-css-extract-plugin
export default {"container":"arrow_container__2Ddqh","icon":"arrow_icon__3WsOk","purple":"arrow_purple__2UKNu","white":"arrow_white__3NatI"};